module.exports = __webpack_public_path__ + "static/img/mini5.85db709b.png";